import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/command-center")({
	component: () => <Navigate to="/strategy" />,
});
